// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import Address from "./types/address";

@jsonObject
export default class Initialized extends PerunMessage {
  @jsonMember(Address) l2Address: Address;

  constructor(l2Address: Address) {
    super();
    this.l2Address = l2Address;
  }

  messageType(): MessageType {
    return Initialized;
  }

  messageTypeName(): MessageTypeName {
    return "Initialized";
  }
}
